import { render } from "./PageFooter.vue?vue&type=template&id=6ef415ee&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=6ef415ee&scoped=true&lang=less"

import exportComponent from "D:\\panorama-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef415ee"]])

export default __exports__